module.exports = __webpack_public_path__ + "img/image-not-found.5a71fa48.png";